var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFerrisWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "darkblue",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-ferris-wheel-icon lucide-ferris-wheel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.8 15-3.5 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.7 7-3.5 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 9 3.3 7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.7 17-3.5-2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m9 22 3-8 3 8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22h8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.7a9 9 0 1 0-12 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerrisWheel);
export default __webpack_public_path__ + "static/media/ferris-wheel.f20b55afae104333474f70e0e246df21.svg";
export { ForwardRef as ReactComponent };